import { atom } from 'jotai'

export const isDarkState = atom(false)

export const isDarkTextState = atom((get) => (get(isDarkState) ? '黑暗' : '明亮'))
